import api from "./apiSmartLogistics";

export default {
  GetStocksInternal() {
    return api.get("Stocks/GetStocksInternal");
  },
  GetStockInternal(id) {
    return api.get("Stocks/GetStockInternal/" + id);
  },
  GetStocks(databaseCode) {
    return api.get("Stocks/GetStocks/" + databaseCode);
  },
  GetStocksDBNames() {
    return api.get("Stocks/GetStocksDBNames");
  },
  GetStocksServers() {
    return api.get("Stocks/GetStocksServers");
  },
  AddStock(stock) {
    return api.post("Stocks", stock);
  },
  UpdateStock(stock) {
    return api.put("Stocks", stock);
  },
  GetCodiceSocieta(search) {
    return api.post("Stocks/GetCodiceSocieta", search);
  }
};
